// removed by extract-text-webpack-plugin
module.exports = {"container":"_3xsHmwg4aHXUA_2KbA_mAJ","logo":"_2DPVOJAVVHrwW7PtN635k","sideNav":"_2VNJPluJizCHRzUGqUVUcj","link":"jgkK5SUj-PyXZUdaChbDi","active":"_39V4KIvQD3DMs221ImJbuk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/header.css
// module id = 1093
// module chunks = 0